<template>
  <v-container fluid>
    <Slogen class="authWrap" />
    <v-row class="justify-center">
      <v-col xs="12" sm="6" md="4">
        <v-stepper v-if="user" v-model="step">
          <!-- <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">
              Verify
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">
              Set Password
            </v-stepper-step>
          </v-stepper-header> -->

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card elevation="4" class="">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="user.name"
                        label="Full Name"
                        :autocomplete="'false'"
                        :rules="rules.text"
                        hide-details
                        @input="changes = true"
                        required
                        dense
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="user.email"
                        label="E-Mail"
                        hide-details
                        placeholder="E-Mail"
                        @input="changes = true"
                        disabled
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-select
                        :items="roles"
                        label="User Role"
                        v-model="user.role"
                        autocomplete="off"
                        disabled
                        hide-details
                        dense
                      >
                      </v-select>
                    </v-col>
                    <v-col>
                      <v-text-field
                        v-model="user.groupName"
                        label="Company/Group"
                        :rules="rules.text"
                        disabled
                        required
                        dense
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="info" @click="step = 2">
                    <v-icon>mdi-check-decagram</v-icon> Verify
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card>
                <v-card-title>
                  <v-icon class="mr-1">mdi-form-textbox-password</v-icon>
                  Set Your Password
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    v-model="user.password"
                    label="Password"
                    :autocomplete="false"
                    :rules="rules.text && rules.pass"
                    :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passShow ? 'text' : 'password'"
                    @click:append="passShow = !passShow"
                    hint="At least 8 characters & one letters or numbers"
                  >
                  </v-text-field>
                  <v-text-field
                    v-model="password2"
                    label="Password Validation"
                    :rules="rules.text && rules.pass"
                    :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passShow ? 'text' : 'password'"
                    @click:append="passShow = !passShow"
                  >
                  </v-text-field>
                </v-card-text>
                <v-row class="">
                  <v-col>
                    <v-btn @click="step = 1" outlined> Back </v-btn>
                  </v-col>
                  <v-spacer> </v-spacer>
                  <v-col cols="auto">
                    <v-btn
                      :disabled="
                        !user.password ||
                        !user.password.length ||
                        password2 !== user.password
                      "
                      label="Save"
                      color="success"
                      @click="save"
                    >
                      <v-icon dark small class="mr-2">
                        mdi-party-popper
                      </v-icon>
                      Complete
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
        <v-card v-else elevation="4">
          <v-card-text class="text-center pa-10">
            <h2 class="my-5">
              <v-icon>mdi-badge-account-alert</v-icon> Token is Expired or
              invalid
            </h2>
            <p>Please contact your admin or Pine3 support team.</p>
            <v-btn class="my-2" to="/" outlined color="secondary">Back to Login</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import Slogen from "@/components/Slogen.vue";
import { validations } from "@/utils";
import { RoleType } from "@/types";

export default Vue.extend({
  components: { Slogen },
  name: "InviteView",
  data() {
    return {
      step: 1,
      user: {
        name: "",
        email: "",
        password: "",
        group: "",
        groupName: "",
        role: RoleType.USER,
      },
      rules: {
        text: [validations.empty],
        email: [validations.email],
        pass: [validations.password.len, validations.password.strength],
      },
      roles: [
        { text: "Admin", value: 2 },
        { text: "User", value: 3 },
      ],
      changes: false,
      fresh: true,
      password2: "",
      passShow: false,
      error: { type: "", msg: "" },
    };
  },
  methods: {
    async save() {
      console.log(this.selectedGroup, this.user);

      const req = await this.$store.dispatch("Users/saveUser", this.user);
      if (req.error) {
        return (this.error = req.error);
      }
      await this.$store.dispatch("Users/sendConfirmation", this.user);
      this.$router.push("/");
    },
  },
  async created() {
    const { token } = this.$route.params;

    this.user = await this.$store.dispatch("Users/checkInvite", token);
  },
  computed: {
    valid() {
      return this.password2 === this.user.password;
    },
  },
});
</script>
<style scoped>
.authWrap {
  margin-top: 10vh;
}
</style>
